import {FC, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {Box, Stack} from "@mui/material";
import {ILessonEntity} from "@buildwitt/shapeshift-types";
import {useNavigate, useParams} from "react-router-dom";
import {APIState} from "@buildwitt/shapeshift-identity";
import {AdminLessonPageContent} from "./AdminLessonPageContent";
import {AdminLessonPageContent as AdminLessonPageContentNew} from "../../ContentCreation/AdminLessonPageContent";

const useStyles = makeStyles()((theme) => ({
	adminLessonPage: {},
	adminLessonPageNew: {
		"& > div": {
			width: "980px",
			maxWidth: "100%"
		}
	}
}));

interface IProps {
	newContent?: boolean;
}

export const AdminLessonPage: FC<IProps> = ({newContent}) => {
	const {lessonId} = useParams();
	const {classes} = useStyles();
	const navigate = useNavigate();
	const entityId = lessonId ? parseInt(lessonId) : undefined;
	const [locale, setLocale] = useState<string>();

	const handleOnSaveResponse = (e: APIState<ILessonEntity>): void => {
		if(!e.data)
			return;

		navigate("/admin/lessons/" + e.data.id.toString() + "/edit")
	}

	const handleOnSaveResponseNew = (e: APIState<ILessonEntity>): void => {
		if(!e.data)
			return;

		navigate("/admin/lessons/" + e.data.id.toString() + "/edit-new")
	}

	const handleOnGetResponse = (entityApiResponse: APIState<ILessonEntity>): void => {
		if(!entityApiResponse.data || entityApiResponse.isLoading)
			return;

		if(entityApiResponse.statusCode === 404){
			navigate("../")
		}

		if(!entityApiResponse.data)
			return;

		if(entityId && entityApiResponse.data.id !== entityId){
			navigate("/admin/lessons/" + entityApiResponse.data.id.toString() + "/edit?locale=" + entityApiResponse.data.locale)
		}
	}

	const handleOnGetResponseNew = (entityApiResponse: APIState<ILessonEntity>): void => {
		if(!entityApiResponse.data || entityApiResponse.isLoading)
			return;

		if(entityApiResponse.statusCode === 404){
			navigate("../")
		}

		if(!entityApiResponse.data)
			return;

		if(entityId && entityApiResponse.data.id !== entityId){
			navigate("/admin/lessons/" + entityApiResponse.data.id.toString() + "/edit-new?locale=" + entityApiResponse.data.locale)
		}
	}

	const handleOnDeleteResponse = (deleteApiResponse: APIState<ILessonEntity>): void => {
		if(!deleteApiResponse.data || deleteApiResponse.isLoading)
			return;

		if(deleteApiResponse.statusCode === 200){
			navigate("/admin/lessons")
		}
	}

	const lessonIdParsed = lessonId ? parseInt(lessonId) : undefined

	return newContent ?
		(
			<Stack className={classes.adminLessonPageNew}>
				<AdminLessonPageContentNew
					lessonId={lessonIdParsed}
					onSaveResponse={handleOnSaveResponseNew}
					onDeleteResponse={handleOnDeleteResponse}
					onGetResponse={handleOnGetResponseNew}
					onLocaleChange={e => setLocale(e)}
					locale={locale}
				/>
			</Stack>
		)
		: (
			<Box className={classes.adminLessonPage}>
				<AdminLessonPageContent
					lessonId={lessonIdParsed}
					onSaveResponse={handleOnSaveResponse}
					onDeleteResponse={handleOnDeleteResponse}
					onGetResponse={handleOnGetResponse}
					onLocaleChange={e => setLocale(e)}
					locale={locale}
				/>
			</Box>
		);
}